import { render, staticRenderFns } from "./TypeStatusProductionForm.vue?vue&type=template&id=894e1640&"
import script from "./TypeStatusProductionForm.vue?vue&type=script&lang=js&"
export * from "./TypeStatusProductionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports